import { Box, Skeleton } from '@factorialco/deprecated-design-system'
import { NotesTextEditorSkeleton } from '@factorialco/f0-react/dist/experimental'

interface MeetingSkeletonProps {
  aiChatOpen?: boolean
}

export const MeetingSkeleton = ({ aiChatOpen = false }: MeetingSkeletonProps) => {
  return (
    <Box height="full" flexDirection="row" style={{ overflow: 'hidden' }}>
      <Box height="full" flexGrow overflowX="hidden">
        <NotesTextEditorSkeleton withHeader withTitle />
      </Box>
      {aiChatOpen && (
        <Box
          flexNoShrink
          height="full"
          style={{ width: '360px' }}
          border={{ left: { width: 's1', style: 'solid', color: 'grey200' } }}
          flexDirection="column"
          position="relative"
        >
          <Box
            position="absolute"
            width="full"
            alignItems="flexEnd"
            padding="s12"
            style={{ top: '0', left: '0' }}
          >
            <Skeleton isLoading height="s32" width="s32" />
          </Box>

          <Box
            paddingX="s16"
            paddingBottom="s16"
            flexGrow
            gap="s20"
            flexDirection="column"
            overflowY="auto"
            style={{ paddingTop: '56px' }}
          >
            <Box flexDirection="row" justifyContent="flexEnd">
              <Box style={{ width: '70%' }}>
                <Skeleton isLoading height="s40" width="full" />
              </Box>
            </Box>
            <Box flexDirection="column" alignItems="flexStart" gap="s4">
              <Box style={{ width: '90%' }}>
                <Skeleton isLoading height="s64" width="full" />
              </Box>
            </Box>
            <Box flexDirection="row" justifyContent="flexEnd">
              <Box style={{ width: '80%' }}>
                <Skeleton isLoading height="s48" width="full" />
              </Box>
            </Box>
            <Box flexDirection="column" alignItems="flexStart" gap="s4">
              <Box style={{ width: '85%' }}>
                <Skeleton isLoading height="s80" width="full" />
              </Box>
            </Box>
          </Box>
          <Box flexNoShrink position="relative" paddingX="s8" paddingBottom="s8" gap="s8">
            <Skeleton isLoading height="s96" width="full" />
          </Box>
        </Box>
      )}
    </Box>
  )
}
